import React, { Component } from "react";
// This was giving a tiny warning in Browser debug

// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import { Router, Switch, Route } from "react-router-dom";
// import { withRouter } from "react-router";
// import queryString from 'query-string';

import { Provider } from "react-redux";
import history from "./history";
import MainMenuPage from "./components/MainMenuPage";
import FlashCardsDifficultyPage from "./components/FlashCards/FlashCardsDifficultyPage";
import FlashCard from "./components/FlashCards/FlashCard";
import FastQuizDifficultyPage from "./components/FastQuiz/FastQuizDifficultyPage";
import QuizPage from "./components/FastQuiz/QuizPage";
import ScoreReport from "./components/ScoreReport";
import TestYourKnowledgePage from "./components/TestYourKnowledgePage";
import AboutUsPage from "./components/AboutUsPage";
import LoaderComponent from "./components/LoaderComponent";
import { CookiesProvider, withCookies } from "react-cookie";
import { connect } from "react-redux";
import { getQuestionSetDetails } from "./actions";
import global from "./global";
import "font-awesome/css/font-awesome.min.css";

const routes = [
  {
    id: 1,
    path: "/",
    component: MainMenuPage,
  },
  {
    id: 2,
    path: "/flashcards-difficulty",
    component: FlashCardsDifficultyPage,
  },
  {
    id: 3,
    path: "/flashcard/:_flashcardId",
    component: FlashCard,
  },
  {
    id: 4,
    path: "/fastquiz-difficulty",
    component: FastQuizDifficultyPage,
  },
  {
    id: 5,
    // path: "/fastquiz/:_fastquizId",
    path: "/fastquiz",
    component: QuizPage,
  },
  {
    id: 6,
    path: "/score-report",
    component: ScoreReport,
  },
  {
    id: 7,
    path: "/knowledge-test",
    component: TestYourKnowledgePage,
  },
  {
    id: 8,
    path: "/about-us/",
    component: AboutUsPage,
  },
  {
    // This is an attempt by me to test and add a launch route with a starting parameter.
    // This can be removed or changed as needed... - Scott Lynn, Oct 2022
    id: 9,
    path: "/launch/:params",
    component: MainMenuPage,
  },
  {
    id: 10,
    path: "/index.html",
    component: MainMenuPage,
  },
];

//=============================================================================
// Class Routes
//=============================================================================
class Routes extends Component {
  
  //---------------------------------------------------------------------------
  constructor() {
    super();
    this.state = {
      isLoading: true,
    };
  }

  //---------------------------------------------------------------------------
  componentDidMount() {
    console.log("Routes.jsx - componentDidMount");
    console.log("URL: " + window.location);
    let today = new Date();
    global.config.dGameInit = today.toISOString();

    // Detect launching QSID
    // Did we get here by the launch URL?
    let sURL = window.location.toString();

    // Need to handle production routing to qsid
    // /torah/index.html?qsid=3
    if (sURL.includes('/launch/') || sURL.includes('?')) 
    {
      // Convert to one from the other, one-time hit at launch
      // And grab parameters found if any
      let aURL = sURL.replace('/launch/', '&').replace('?', '&').split('&');
      // This skips the page URL except when there are arguments, 
      // then includes it with no params, so it provides ambiguous results
      // let aURL = sURL.slice(sURL.indexOf('?') + 1).split('&');

      // const params = queryString.parse(this.props.location.search);
      // console.log('Do something with it', params);    

      if (aURL.length > 1) {
        console.log(aURL);
        console.log(aURL.length);
      
        // Loop through params to check options on load
        // Possible options - all stored in global.config
        // setqsid=X -> stored in QSID
        // session=abc -> stored in debugQuestionType
        // debugqt=MIX -> stored in debugQuestionType
        // debugqm=x -> stored in debugQuestionModified (number of minutes old for testing recent questions)

        for(var i = 1; i < aURL.length; i++)
        {
          let aTarget = aURL[i].split("=");
          if (aTarget.length === 2) 
          {
            if ((aTarget[0] === "qsid") || (aTarget[0] === "setqsid")) {
              // FLAG-QSID
              // We possibly have the target question set for this quiz/game
              let iTarget = parseInt(aTarget[1]);
              if ((!isNaN(iTarget)) && (iTarget > -1)) {
                global.config.QSID = iTarget;
                console.log("LAUNCH PARAM - RequestedQSID: " + global.config.QSID);
              }    
            } 

            else if (aTarget[0] === "session") {
              // Used to authenticate session and load user and tokenization from backend later
              global.config.sessionID = aTarget[1];
              console.log("LAUNCH PARAM - Session: " + global.config.sessionID);
            } 

            else if ((aTarget[0] === "debugqt") && (aTarget[1].length === 3)) {
              // FLAG-DEBUG-QUESTIONTYPE 
              global.config.debugQuestionType = '&qtype=' + aTarget[1];
              console.log("LAUNCH PARAM - DQT: " + global.config.debugQuestionType);
            } 

            else if (aTarget[0] === "debugqm") {
              // TODO we need to add this param to backend for testing the newest questions added
              // global.config.debugQuestionType = aTarget[1];
              let iValue = parseInt(aTarget[1]);
              if ((!isNaN(iValue)) && (iValue > -1)) {
                global.config.debugQuestionModified = iValue;
                console.log("LAUNCH PARAM - DQM: " + global.config.debugQuestionModified);
              }    
            }

          }
          else 
          {
            // Checking for params with no arguments
            // Currently we don't have any...
          }
        }
      } // End of URL has arguments check
    } // End of if '/launch/'

    console.log("BASE URL: " + global.config.websiteBaseName);
    console.log("BACKEND: " + global.config.apiBaseUrl);
    console.log("REQUESTED QSID: " + global.config.QSID);

    // TODO Hide console.log in production
    // if (process.env.NODE_ENV === "production") {
    //   if (window) {
    //     window.console.log = function () {};
    //   }
    // }

    // if (typeof window.orientation !== "undefined" || navigator.userAgent.indexOf('IEMobile') !== -1) {
    // 	document.querySelector('body').classList.remove('fix-header', 'fix-sidebar');
    // }

    this.props
      .getQuestionSetDetails("?qsid=" + global.config.QSID)
      .then((res) => {
        this.setState(
          {
            isLoading: false,
          },
          () => {
            const { questionSetDetails } = this.props;
            // We have the details now...
            console.log("GameInit: " + global.config.dGameInit);
            console.log("QSDFetch: " + global.config.dQSLoaded);
            let themeName = "";
            switch (questionSetDetails.QSTheme) {
              case "SPACE":
                themeName = "theme-space";
                break;

                case "EGYPT":
                  themeName = "theme-egypt";
                  break;
  
                case "ANCIENTGREECE":
                themeName = "theme-ancient-greece";
                break;

              default:
                break;
            }
            document.documentElement.className = "";
            document.documentElement.classList.add(themeName);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //---------------------------------------------------------------------------
  // Main Render Function
  //---------------------------------------------------------------------------
  render() {
    const { isLoading } = this.state;
    // console.log("BaseURL is " + global.config.websiteBaseName);
    return isLoading ? (
      <LoaderComponent loading={isLoading} />
    ) : (
      <CookiesProvider>
        <Provider store={this.props.store}>
          <Router basename={global.config.websiteBaseName} history={history}>
            <Switch>
              {routes.map((route, index) => {
                // console.log("Routes.jsx - render - " + route.path);
                return (
                  <Route
                    key={index}
                    exact
                    // path={`${process.env.PUBLIC_URL}` + route.path}
                    path={route.path}
                    render={(props) => (
                      <route.component
                        cookies={this.props.cookies}
                        {...props}
                      />
                    )}
                  />
                );
              })}
            </Switch>
          </Router>
        </Provider>
      </CookiesProvider>
    );
  }
}

//-----------------------------------------------------------------------------
const mapStateToProps = (state) => {
  return {
    questionSetDetails: state.questionSetDetails,
  };
};

//-----------------------------------------------------------------------------
export default connect(mapStateToProps, {
  getQuestionSetDetails,
})(withCookies(Routes));
